import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPajakWpService = new CrudCustom('/transaksi-pajak-wp');
export default TransaksiPajakWpService;
